import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DocumentsPublic } from '@/components/DocumentsPublic';

const documentsSearchSchema = z.object({
  documentId: z.string().optional(),
});

export const Route = createFileRoute('/_auth/operations/documents/')({
  component: DocumentsRoute,
  validateSearch: documentsSearchSchema,
});

function DocumentsRoute() {
  const { documentId } = Route.useSearch();

  return <DocumentsPublic initialDocumentId={documentId} />;
}
